import React, { useEffect } from "react"
import { connect } from "react-redux"
import { Box } from "@infotech/uikit-grid"
import FieldSet from "@infotech/uikit-fieldset"
import Select from "@infotech/uikit-select"
import DeletedIcon from "src/icons/deleted.svg"
import get from "lodash/get"
import cn from "classnames"
import OkayIcon from "src/icons/okayMultiselect.svg"

import { selectResource } from "src/engine/modules/api/selectors"
import { requestApiEntity } from "src/engine/modules/api/actions/creators"
import styles from "./styles.css"

const createText = `Чтобы добавить ресурсы, создайте событие.`
const blockText = `Редактирование списка ресурсов запрещено.`

// eslint-disable-next-line consistent-return
const getOptionIcon = ({ isAllowed, isDeleted }) => {
  if (isDeleted) {
    return <DeletedIcon className={cn(styles.OptionIcon, styles.DeletedIcon)} />
  }
  if (isAllowed) {
    return (
      <OkayIcon size="medium" color="#2475eb" className={styles.OptionIcon} />
    )
  }
}

const ResourcePreview = ({
  uuid,
  id,
  option,
  allowedResourceTypes,
  requestApiEntity,
}) => {
  useEffect(() => {
    if (uuid) {
      requestApiEntity({ name: `resources`, uuid })
    }
  }, [uuid])
  return (
    <Box flex loose pt="1md" pb="1md" className={styles.Option}>
      {getOptionIcon({
        isAllowed: allowedResourceTypes.includes(id),
        isDeleted: !!option.deletedBy,
      })}
      <Box loose pl="2md" mt="2px" className={styles.OptionTitle}>
        {option.name}
      </Box>
    </Box>
  )
}

const ResourceNewForm = ({
  isNew,
  requestApiEntity,
  resource,
  getTestAttribute,
  initialResource,
  allowedResourceTypes,
}) => {
  return (
    <Box loose>
      <Box pt="2md" pr="2md" pl="2md">
        <FieldSet caption="Ресурсы">
          <div data-testid={getTestAttribute(`resource-multiselect`)}>
            <Select
              placeholder="Введите название ресурса"
              isDisabled
              value={null}
            />
          </div>
        </FieldSet>
        <Box loose className={styles.FirstCreateLabel}>
          {isNew ? createText : blockText}
        </Box>
      </Box>
      <Box pt="2md">
        {initialResource[0] && (
          <ResourcePreview
            uuid={initialResource[0]}
            id={get(resource, `data.resourceTypeId`)}
            option={get(resource, `data`)}
            allowedResourceTypes={allowedResourceTypes}
            requestApiEntity={requestApiEntity}
          />
        )}
      </Box>
    </Box>
  )
}

export default connect(
  state => ({
    resource: selectResource(state),
  }),
  {
    requestApiEntity,
  },
)(ResourceNewForm)
